import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AuthActions } from '../../actions';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faUserCircle, faSignOutAlt} from '@fortawesome/fontawesome-free-solid';

import './topNavigation.scss';

class TopNavigation extends Component { 
    constructor(props) {
        super(props);

        this.logout = this.logout.bind(this);
    }

    logout() {
        this.props.dispatch(AuthActions.logout());
    }

    render() {
        const userName = this.props.user.data ? this.props.user.data.name : "";
        return (
            <nav className="mainTopNav">
                <div className="welcomeUser">
                    <div className="userIcon">
                        <FontAwesomeIcon icon={faUserCircle}/>
                    </div>
                    <div>
                        שלום {userName}!
                        <div className="logOut" onClick={this.logout}>
                            <FontAwesomeIcon icon={faSignOutAlt}/> ליציאה
                        </div>
                    </div>
                </div>
            </nav>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer
    }   
}

const SideNavigationWithRedux = connect(mapStateToProps)(TopNavigation);

export {SideNavigationWithRedux as TopNavigation};


// WEBPACK FOOTER //
// ./src/components/PageTemplate/TopNavigation.jsx